export default ({ COLORS }) => ({
  result: {
    height: '220px',
    overflow: 'auto',
    position: 'relative'
  },
  search: {
    margin: '5px 0 -5px',
    width: '100%'
  },
  pendingOverlay: {
    animation: '0.3s fadeIn',
    position: 'absolute',
    width: 'calc(100% - 32px)',
    height: 'calc(100% - 16px)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255, 255, 255, 0.5)'
  },
  finishAsParent: {
    margin: '0 0 10px'
  },
  finishAsIndividual: {
    margin: '10px 0'
  },
  footer: {
    flexDirection: 'column'
  },
  buttonHolder: {
    marginBottom: '16px'
  },
  '@keyframes fadeIn': {
    from: { opacity: '0' },
    to: { opacity: '1' }
  }
})
